// extracted by mini-css-extract-plugin
export var actionButton = "_8b-0";
export var attachmentLine = "_8b-1";
export var fileInput = "_8b-2";
export var fileUploadWrapper = "_8b-4";
export var footer = "_8b-3";
export var modalContent = "_8b-5";
export var paperclip = "_8b-6";
export var quillEditor = "_8b-7";